import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=1288f22a&lang=pug&"
import script from "./Tariffs.vue?vue&type=script&lang=ts&"
export * from "./Tariffs.vue?vue&type=script&lang=ts&"
import style0 from "./Tariffs.vue?vue&type=style&index=0&id=1288f22a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports